const findFolderIdByFileId = (
  folders: { [key: number]: { filesIds: number[]; id: number } },
  fileId: string
) => {
  if (!folders) return;

  const foldersArray = Object.values(folders);

  const foundFolder = foldersArray.find((folder) =>
    folder.filesIds?.includes(+fileId)
  );

  return foundFolder?.id;
};

export default findFolderIdByFileId;
